import React, {useEffect, useMemo, useRef, useState} from "react";
import Podcasts from "../podcasts/Podcasts";
import PrizeTimer from "../prizeTimer/PrizeTimer";
import OriginalPosts from "../originalPosts/OriginalPosts";
import Narratives from "../narratives/Narratives";
import MoreCards from "../moreCards/MoreCards";
import Recommendations from "../recommendations/Recommendations";
import LastNews from "../lastNews/LastNews";
import {sliceIntoChunks} from "../../utils/sliceIntoChunks";
import panel, {addData, usePanel} from "../../redux/reducer/panel";
import {useDispatch} from "react-redux";
import {useRouter} from "next/router";
import {createNewsDate} from "../../utils/data/createData";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import classNames from "classnames";
import CurrentCirculations from "../currentCirculations/CurrentCirculations";
import stylesCC from "../currentCirculations/CurrentCirculations.module.scss"
import styles from "./ContentPage.module.scss";

const ContentPage = React.forwardRef(
  function ContentPage({data, className}, ref) {
    const [recordsCount, setRecordsCount] = useState(17)
    const {query: {page}} = useRouter()
    const {content, podcasts, narratives, authorsContent, jackpot, horoscope, main, header} = data;
    const {receivedData} = usePanel()
    const dispatch = useDispatch()


    const superBets = useMemo(() => {
      const currentHeadBets = header.headings.find(item => item.href.slice(1) === page)?.bets
      return currentHeadBets || main?.bets

    }, [page, data])


    const moreClick = () => {
      dispatch(panel.thunks.getMoreArticles({page, recordsCount: recordsCount}))
      setRecordsCount(prev => prev + 6)
    }

    useEffect(() => {
      dispatch(addData(content.items))
    }, [content.items])

    const testNarratives = useMemo(() => {
      return narratives.items?.map((item, index) => {
        return {
          index,
          identifier: item.identifier,
          title: item.title,
          image: item.preview,
          imageM: item.preview_mobile,
          color: item.headings[0]?.color === "#ffffff" ? "white" : item.headings[0]?.color,
          tags: [{text: item.headings[0]?.title}],
          list: item.content,
          button: item.button_url || item.button_text ? {
            href: item.button_url,
            text: item.button_text
          } : false
        }
      })
    }, [narratives.items]);

    const podcastList = useMemo(() => {
      return podcasts.items.map((props) => {
        const {title, description, links, preview, href, external_source_link} = props;
        return {
          title,
          extraLink: external_source_link,
          text: description,
          image: preview,
          list: [...links],
          href,
          button: {
            textBtn: "Перейти"
          }
        }
      })
    }, [podcasts.items]);

    const authorsList = useMemo(() => {
      return createNewsDate(authorsContent.items)
    }, [authorsContent.items])

    const newsList = useMemo(() => {
      const arrData = receivedData.length ? receivedData : content.items;
      return createNewsDate(arrData)
    }, [receivedData, content.items])

    const lastNews = useMemo(() => {
      return [...newsList].splice(0, 5);
    }, [newsList])


    const recommendationList = sliceIntoChunks(newsList.slice(5), 6).map((data, index) =>
      <CSSTransition key={`recommendation-${index}`} timeout={1000} classNames={"recommendations"}>
        <Recommendations key={index}
                         index={index}
                         list={data}
        />
      </CSSTransition>
    )

    return (
      <div className={classNames(styles.contentPage, className)} ref={ref}>

        <CurrentCirculations list={superBets} className={stylesCC.currentCirculations_main}/>
        <LastNews list={lastNews}/>
        {testNarratives.length > 0 && <Narratives list={testNarratives}/>}
        {recommendationList[0]}
        {jackpot[`jackpot`]?.lottery?.draw &&

              <PrizeTimer info={jackpot[`jackpot`]}/>

        }
        {authorsList.length &&  <OriginalPosts list={authorsList} mod={"dark"}/>}
        {recommendationList[1]}
        {podcastList.length && <Podcasts list={podcastList} />}

        <TransitionGroup component={null}>
          {[...recommendationList].slice(2)}
        </TransitionGroup>
        <AppearSensor partialVisibility={true}>
          {({isVisible}) =>
            <MoreCards onClick={moreClick} isShow={isVisible}/>
          }
        </AppearSensor>


      </div>
    )
      ;
  });
export default ContentPage;
ContentPage.propTypes = {};

